export default __webpack_public_path__ + "static/media/dashbarod1.4f9f54b1.mp4";